const isPROD = (process.env.NODE_ENV === 'production');

export const Helper = {
    isPROD,
}